import BlueFertilizerOnSoilImage from "../../images/tasks/blue-fertilizer-on-soil.jpeg";
import SeaweedInTransparenttJarImage from "../../images/tasks/seaweed-in-transparent-jar.jpeg";
import WateringCanWithSteamLeavingImage from "../../images/tasks/watering-can-with-steam-leaving.jpeg";
export const fertiliseCalendar = [
  {
    name: "Fertilise Granular/Compost",
    description:
      "Fertiliser is any organic or inorganic material of natural or synthetic origin that is added to soil to supply one or more plant nutrients essential to the growth of plants.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Bi-annual",
    bestMonths: ["September", "October", "March", "April"],
    otherMonths: ["January", "February", "April", "May"],
    image: BlueFertilizerOnSoilImage,
  },
  {
    name: "Fertilise Liquid",
    description:
      "Fertiliser is any organic or inorganic material of natural or synthetic origin that is added to soil to supply one or more plant nutrients essential to the growth of plants.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Annual",
    bestMonths: ["August"],
    otherMonthss: ["September", "October"],
    applicationFrequency: "Fortnightly",
    applicationDuration: "1 month",
    image: WateringCanWithSteamLeavingImage,
  },
  {
    name: "Seasol",
    description:
      "Seasol is a seaweed concentrate used as a plant tonic. It contains a range of nutrients, trace elements and alginates to promote healthy growth in plants, lawns and soil.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "as needed",
    bestMonths: ["August"],
    otherMonths: "all",
    applicationFrequency: "Fortnightly",
    applicationDuration: "1 month",
    image: SeaweedInTransparenttJarImage,
  },
];
